import { Injectable } from '@angular/core';
import { UserService } from '@Services/user.service';
import { AuthService } from '@Services/auth.service';
import { BaseHub } from './base.hub';
import { LoggingService } from '@Services/logging.service';
import { SyncHubStatusService } from '@Services/sync-hub-status.service';

@Injectable({
    providedIn: 'root'
})
export class ClearanceHub extends BaseHub {

    protected hubName: string = "Clearance";
    private callback: (message: ClearanceResponse) => void;

    public route = "clearance";

    constructor(
        public userService: UserService,
        public auth: AuthService,
        protected logger: LoggingService,
        protected statusService: SyncHubStatusService,
    ) {
        super(userService, auth, logger, statusService);
    }

    public initialize(): void {
    }

    public mapMessageHandlers() {
        this.hubConnection.on('ProcessChat', (message: any, sessionId: string) => {
                this.logger.logInfo("ClearanceHub: Received ProcessChat message from server.", message);
                this.callback({
                    SessionId: sessionId,
                    Exposition: message.Exposition,
                    RecommendedCandidate: message.RecommendedCandidate,
                    AdditionalCandidates: message.AdditionalCandidates
                })
            }
        );
    }

    public joinChatSession(sessionId: string, callback: (message: ClearanceResponse) => void): void {
        if (!this.join(sessionId)) {
            return;
        }
        this.callback = callback;
    }

    public leaveChatSession(sessionId: string): void {
        if (!this.leave(sessionId)) {
            return;
        }
        this.logger.logInfo(`${this.hubName}: User has left clearance chat ${sessionId}.`);
    }
}

export interface ClearanceResponse {
    SessionId: string;
    Exposition: string;
    RecommendedCandidate: ClearanceCandidate;
    AdditionalCandidates: ClearanceCandidate[];
}

export interface ClearanceCandidate {
    AccountId: string;
    ProducerId?: string;
    Name: string;
    DBA?: string;
    Address1?: string;
    Address2?: string;
    Address3?: string;
    City?: string;
    State?: string;
    PostalCode?: string;
    County?: string;
    Website?: string;
    FEIN?: string;
    Phone?: string;
    Confidence: number;
}
